<header id="header">
  <nav class="nav navbar navbar-expand-md navbar-light fixed-top bg-primary shadow-sm">
    <div class="container">
      <a class="btn p-0 navbar-brand" routerLink="/">
        <img
          src="../../assets/els/images/logos/eurogeo-full-colour.svg"
          class="d-inline-block align-top"
          alt="Eurogeographics Logo"
          loading="lazy"
          width="150"
          height="60"
        />
        <span class="sr-only">Eurogeographics</span>
      </a>
      <a class="sr-only sr-only-focusable btn text-white" [href]="skipLinkPath">
        Skip to main content
      </a>
      <button
        class="btn btn-primary text-white"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#navigationMenu"
        aria-controls="navigationMenu"
      >
        <i class="bi bi-list nav__toggle-icon" aria-hidden="true" title="Navigation Menu"></i>
      </button>

      <div
        class="offcanvas offcanvas-end"
        tabindex="-1"
        id="navigationMenu"
        aria-labelledby="navigationMenuLabel"
      >
        <div class="offcanvas-header justify-content-end">
          <button
            type="button"
            class="btn btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="offcanvas-body">
          <ul class="list-unstyled nav__ul">
            <li>
              <a routerLink="/explore-map/egm-erm-basemap">Explore Map</a>
            </li>
            <li>
              <a routerLink="/access-data">Access Data</a>
            </li>
            <li>
              Datasets
              <ul class="list-unstyled">
                <li *ngFor="let dataset of datasets">
                  <a routerLink="/datasets/{{ dataset.mapServiceURLSlug }}">{{ dataset.name }}</a>
                </li>
              </ul>
            </li>
            <li>
              <a routerLink="/frequently-asked-questions">Frequently Asked Questions</a>
            </li>
            <li>
              <a routerLink="/contact">Contact Us</a>
            </li>
            <li>
              <a routerLink="/privacy-policy">Privacy</a>
            </li>
            <li>
              <a routerLink="/terms-conditions">Terms & Conditions</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</header>
